import styled from "styled-components";
import { CLOUDN_COLORS, COLORS } from "../../../constants/colors";
import { LinksProps } from "../../../constants/types";
import { useCallback } from "react";

const Links = (props: LinksProps) => {
  const onClick = useCallback(() => {
    window.open(props.link, "_blank");
  }, []);
  return <Container onClick={onClick}>{props.name}</Container>;
};

export default Links;

const Container = styled.div`
  width: 100%;
  height: 8%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  font-weight: 500;
  color: ${COLORS.lightFontColor};
  cursor: pointer;

  &:hover {
    color: ${CLOUDN_COLORS.logoSkyBlue};
  }
`;
